import { Grid, Card, CardHeader, CardContent, Stack, Typography, Table, TableHead, TableRow, TableCell, TableBody, Chip } from '@mui/material';
import { Apartment, People, ReceiptLong, MonitorHeart } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { StatCard } from '../../components/StatCard';
import { EmptyState } from '../../components/EmptyState';
import { platformApi } from '../../api/platform.api';

export function PlatformDashboardPage() {
  const health = useQuery({ queryKey: ['platform', 'health'], queryFn: () => platformApi.health() });
  const reminders = useQuery({ queryKey: ['platform', 'renewals'], queryFn: () => platformApi.renewalReminders() });
  const h = health.data;

  return (
    <>
      <PageHeader title="Platform Dashboard" subtitle="Fleet-wide tenant health, subscriptions and system status." />
      <Grid container spacing={2} mb={1}>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#1e40af" label="Total Tenants" value={h?.totalTenants ?? 0} icon={<Apartment />} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#16a34a" label="Active Tenants" value={h?.byStatus.active ?? 0} icon={<MonitorHeart />} hint={`Trial ${h?.byStatus.trial ?? 0} · Suspended ${h?.byStatus.suspended ?? 0}`} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#7c3aed" label="Total Users" value={h?.totalUsers ?? 0} icon={<People />} /></Grid>
        <Grid item xs={12} sm={6} lg={3}><StatCard gradient color="#d97706" label="Unpaid Invoices" value={h?.unpaidInvoices ?? 0} icon={<ReceiptLong />} /></Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Tenants by Status" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent>
              <Stack spacing={1.5}>
                {Object.entries(h?.byStatus ?? {}).map(([k, v]) => (
                  <Stack key={k} direction="row" justifyContent="space-between"><Typography variant="body2" textTransform="capitalize">{k}</Typography><Typography variant="subtitle1" fontWeight={700}>{v}</Typography></Stack>
                ))}
                {!h && <Typography variant="body2" color="text.secondary">Loading…</Typography>}
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Upcoming Renewals (30 days)" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              {(reminders.data?.length ?? 0) === 0 ? <EmptyState title="No renewals due" dense /> : (
                <Table size="small">
                  <TableHead><TableRow><TableCell>Tenant</TableCell><TableCell>Plan</TableCell><TableCell>Renewal</TableCell><TableCell align="right">Days</TableCell></TableRow></TableHead>
                  <TableBody>
                    {(reminders.data ?? []).map((r) => (
                      <TableRow key={r.tenantId} hover>
                        <TableCell>#{r.tenantId}</TableCell><TableCell>{r.planCode}</TableCell><TableCell>{r.renewalDate}</TableCell>
                        <TableCell align="right"><Chip size="small" color={r.daysToRenewal <= 7 ? 'error' : 'warning'} label={r.daysToRenewal} /></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
